var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradientBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 974,
    viewBox: "0 0 1440 974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6805",
    "data-name": "Rectangle 6805",
    width: 1440,
    height: 974,
    transform: "translate(0 278)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.51,
    y1: 0.949,
    x2: 0.5,
    y2: 0.481,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17151d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#0f1a43",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#0b1a48",
    stopOpacity: 0.384
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#111e4a",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17151d",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_160",
    "data-name": "Mask Group 160",
    transform: "translate(0 -278)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47953",
    "data-name": "Path 47953",
    d: "M12122.92,17504.955l-15.229-1947.036L10682.92,15099v2405.956Z",
    transform: "translate(-10682.92 -16062.477)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBg);
export default __webpack_public_path__ + "static/media/gradientBg.94479a901686693793f25b7630587671.svg";
export { ForwardRef as ReactComponent };